import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

/* Componentes */
import EditInfoUser from './editInfoUser';
import EditPasswordUser from './editPasswordUser';
import UserPermission from '../../components/UserPermission';

/* Material UI */
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@mui/material/Grid';

import './styles.css';
import Breadcrumbs from '../../components/Breadcrumbs';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },

  textField: {
    width: '100%',
    backgroundColor: '#fff',
  },
}));


export default function UserEdit() {
  const from = useLocation().state?.from;
  const classes = useStyles();
  const history = useNavigate();

  /* Permissão do usuário no sistema */
  let userPermission = UserPermission();

  useEffect(() => {
    if (userPermission !== 'admin') {
      toast.error("Seu usuário não possuí privilégios para acessar essa página!");
      history("/search");
    }
  }, [userPermission, history]);

  if (userPermission !== 'admin') {
    return null;
  } else {
    return (
      <div className="useredit-container">

        <Breadcrumbs
          paths={[
            ...from,
            { href: '', name: 'Ocorrências Atrasadas' },
          ]}
        />

        <div className={classes.root}>
          <Grid container justifyContent="space-between">
            <EditInfoUser userPermission={userPermission} />
            <EditPasswordUser userPermission={userPermission} />
          </Grid>
        </div>
      </div>
    )
  };
};